export const en: Record<string, string> = {
  "refresh.action": "Refresh",
  "refresh.retry": "Retry refresh",
  "refresh.pull": "Pull down to refresh",
  "refresh.release": "Release to refresh",
  "refresh.loading": "Refreshing…",
  "refresh.updated": "Updated",
  "refresh.sessionExpired": "Your session expired. Sign in again to refresh.",
  "refresh.accessLost": "Some information is no longer available to this profile. Pull down to check again.",
  "refresh.overviewPartial": "Some information could not be refreshed. Previous information is still shown. Pull down to try again.",
  "refresh.overviewLoadError": "Could not load all information. Please try again.",
  "refresh.error": "Could not refresh. Your previous results are still shown.",
  "refresh.timeout": "Refresh took too long. Your previous results are still shown.",
  "refresh.applicationsError": "Listings updated, but application status could not refresh. Retry to check your applications.",
  "saved.mobile.title": "Saved items",
  "saved.mobile.emptyTitle": "Your shortlist starts here",
  "saved.mobile.emptyBody": "People, work and services you want to come back to.",
  "saved.mobile.categories": "Explore by category",
  "saved.mobile.tip": "Look for the bookmark icon on profiles and listings.",
  "saved.mobile.search": "Search saved items",
  "saved.mobile.all": "All",
  "saved.mobile.noMatch": "No saved items match.",
  "saved.mobile.clear": "Clear search",
  "saved.mobile.remove": "Remove saved item",
  "saved.mobile.removed": "Removed from saved items",
  "saved.mobile.undo": "Undo",
  "saved.mobile.retry": "Retry",
  "saved.mobile.loading": "Loading saved items…",
  "saved.mobile.loadError": "Could not load saved items. Please try again.",
  "saved.mobile.removeError": "Could not remove this saved item. Please try again.",
  "saved.mobile.undoError": "Could not restore this saved item. Please try again.",
  "saved.mobile.person": "Jobseekers",
  "saved.mobile.profile": "Profiles",
  "saved.mobile.service": "Services",
  "saved.mobile.company": "Companies",
  "saved.mobile.job": "Jobs",
  "saved.mobile.project": "Projects",
  "saved.mobile.rfq": "Requests",
  "saved.mobile.item": "Items",
  "saved.title": "Saved Items",
  "saved.description": "Profiles and listings you've bookmarked across the marketplace.",
  "saved.empty.title": "Nothing saved yet",
  "saved.empty.description": "Tap the bookmark icon on a profile or listing to save it here.",
  "saved.browse": "Browse the marketplace",
  "saved.remove": "Remove",
  "saved.kind.item": "Item",
  "saved.kind.service": "Service",
  "saved.kind.company": "Company",
  "saved.kind.jobseeker": "Jobseeker",
  "saved.kind.profile": "Profile",
  "saved.kind.job": "Job",
  "saved.kind.project": "Project",
  "saved.kind.rfq": "RFQ",
  "discovery.jobseekers": "Jobseekers",
  "discovery.jobs": "Jobs",
  "discovery.services": "Services",
  "discovery.companies": "Companies",
  "discovery.projects": "Project Bidding",
  "discovery.rfqs": "RFQs",
  "discovery.marketplace": "Marketplace",
  "discovery.all": "All",
  "discovery.marketplaceTitle": "Materials, Products & Equipment",
  "discovery.jobseekersCta": "Set up your Jobseeker profile",
  "discovery.offerServiceCta": "Offer a service",
  "discovery.addCompanyCta": "Add your company",
  "discovery.postJobCta": "Post a job",
  "discovery.postProjectCta": "Post a project",
  "discovery.keywords": "Search keywords…",
  "discovery.category": "Category",
  "discovery.skillsField": "Skills / field of work",
  "discovery.filters": "Filters",
  "discovery.sortBy": "Sort By",
  "discovery.noResults": "No Results Found",
  "discovery.viewDetails": "View Details",
  "discovery.save": "Save",
  "discovery.saved": "Saved",
  "discovery.removeSaved": "Remove from saved",
  "discovery.savedHint": "Saved — click to remove",
  "discovery.providers": "Explore Providers",
  "discovery.opportunities": "Find Opportunities",
  "discovery.browse": "Browse",
  "discovery.refine": "Refine your search",
  "discovery.servicesIntent": "Find the service you need.",
  "discovery.jobseekersIntent": "Find people to hire.",
  "discovery.companiesIntent": "Find companies for larger or specialized work.",
  "discovery.jobsIntent": "Find a job that matches your skills.",
  "discovery.projectsIntent": "Find projects and submit your proposal.",
  "discovery.rfqsIntent": "Find service or supply requests you can fulfill and submit your quotation.",
  "discovery.marketplaceIntent": "Shop for materials, products, and equipment for your work.",
  "discovery.keywordsLabel": "Keywords",
  "discovery.locationLabel": "Location",
  "discovery.allCategories": "All Categories",
  "discovery.rating": "Rating",
  "discovery.ratingAll": "All",
  "discovery.verification": "Verification",
  "discovery.verifiedOnly": "Verified only",
  "discovery.clear": "Clear",
  "discovery.results": "results",
  "discovery.sort.rated": "Highest Rated",
  "discovery.sort.newest": "Newest",
  "discovery.sort.price": "Price: Low to High",
  "discovery.quote": "Request Quote",
  "discovery.startingAt": "Starting at",
  "discovery.from": "From",
  "discovery.category.Construction": "Construction",
  "discovery.category.Professional": "Professional",
  "discovery.category.IT": "IT",
  "discovery.category.Electrical": "Electrical",
  "discovery.category.Plumbing": "Plumbing",
  "discovery.category.Supply": "Supply",
  "discovery.verifiedProfession": "Verified profession",
  "discovery.professionExample": "e.g. Nurse",
  "discovery.organizationType": "Organization type",
  "discovery.allTypes": "All types",
  "discovery.temporarilyUnavailable": "Marketplace temporarily unavailable",
  "discovery.loadFailed": "Could not load the marketplace",
  "discovery.loadFailedHint": "We couldn’t load live listings right now.",
  "discovery.tryAgain": "Try again",
  "discovery.broadenSearch": "Try broadening your keywords or location.",
  "discovery.clearFilters": "Clear filters",
  "discovery.jobseekersEmptyHint": "Jobseeker profiles will appear here as the community grows. In the meantime, browse other categories:",
  "discovery.emptyHint": "Check back soon, or browse another category:",
  "discovery.loadingMore": "Loading more…",
  "discovery.loadMore": "Load more",
  "cards.featured": "Featured",
  "cards.availableNow": "Available now",
  "cards.noRatings": "No ratings yet",
  "cards.yearsExperience": "years experience",
  "cards.applicants": "applicants",
  "cards.checking": "Checking…",
  "cards.checkingApplication": "Checking application…",
  "cards.unableToVerify": "Unable to verify",
  "cards.unableToVerifyApplication": "Unable to verify application",
  "cards.applied": "Applied",
  "cards.shortlisted": "Shortlisted",
  "cards.hired": "Hired 🎉",
  "cards.applyNow": "Apply Now",
  "cards.bids": "Bids",
  "cards.deadline": "Deadline:",
  "cards.budget": "Budget",
  "cards.estimatedBudget": "Estimated Budget",
  "cards.privateEstimate": "Your estimate (private)",
  "cards.budgetUnavailable": "Budget not provided",
  "cards.submitBid": "Submit Bid",
  "cards.quote": "Quote",
  "cards.quotes": "Quotes",
  "cards.due": "Due:",
  "cards.lineItem": "line item",
  "cards.lineItems": "line items",
  "cards.submitQuote": "Submit Quote",
  "cards.viewRequest": "View request",
  "cards.inStock": "in stock",
  "cards.inquireToBuy": "Quotation to buy",
  "cards.rent": "Rent",
  "cards.buy": "Buy",
  "cards.since": "Since",
  "cards.viewCompany": "View company",
};

export const tl: Record<string, string> = {
  "refresh.action": "I-refresh",
  "refresh.retry": "Subukang i-refresh muli",
  "refresh.pull": "Hilahin pababa para i-refresh",
  "refresh.release": "Bitawan para i-refresh",
  "refresh.loading": "Nire-refresh…",
  "refresh.updated": "Na-update na",
  "refresh.sessionExpired": "Nag-expire ang iyong session. Mag-sign in muli para i-refresh.",
  "refresh.accessLost": "Hindi na available ang ilang impormasyon sa profile na ito. Hilahin pababa para tingnan muli.",
  "refresh.overviewPartial": "Hindi ma-refresh ang ilang impormasyon. Ipinapakita pa rin ang naunang impormasyon. Hilahin pababa para subukan muli.",
  "refresh.overviewLoadError": "Hindi mai-load ang lahat ng impormasyon. Pakisubukan muli.",
  "refresh.error": "Hindi ma-refresh. Ipinapakita pa rin ang mga naunang resulta.",
  "refresh.timeout": "Masyadong matagal ang pag-refresh. Ipinapakita pa rin ang mga naunang resulta.",
  "refresh.applicationsError": "Na-update ang mga listing, pero hindi ang status ng aplikasyon. Subukan muli para tingnan ang iyong mga aplikasyon.",
  "saved.mobile.title": "Na-save",
  "saved.mobile.emptyTitle": "Dito ang mga na-save mo",
  "saved.mobile.emptyBody": "Mga tao, trabaho at serbisyong gusto mong balikan.",
  "saved.mobile.categories": "Tuklasin ayon sa uri",
  "saved.mobile.tip": "Hanapin ang bookmark sa mga profile at listing.",
  "saved.mobile.search": "Hanapin sa na-save",
  "saved.mobile.all": "Lahat",
  "saved.mobile.noMatch": "Walang tugma sa na-save.",
  "saved.mobile.clear": "Burahin ang paghahanap",
  "saved.mobile.remove": "Alisin sa na-save",
  "saved.mobile.removed": "Inalis sa na-save",
  "saved.mobile.undo": "Ibalik",
  "saved.mobile.retry": "Subukan muli",
  "saved.mobile.loading": "Kinukuha ang na-save…",
  "saved.mobile.loadError": "Hindi makuha ang na-save. Subukan muli.",
  "saved.mobile.removeError": "Hindi maalis ang na-save. Subukan muli.",
  "saved.mobile.undoError": "Hindi maibalik ang na-save. Subukan muli.",
  "saved.mobile.person": "Jobseeker",
  "saved.mobile.profile": "Mga profile",
  "saved.mobile.service": "Serbisyo",
  "saved.mobile.company": "Kompanya",
  "saved.mobile.job": "Trabaho",
  "saved.mobile.project": "Proyekto",
  "saved.mobile.rfq": "Mga hiling",
  "saved.mobile.item": "Mga item",
  "saved.title": "Mga Naka-save na Item",
  "saved.description": "Mga profile at listahang na-bookmark mo sa marketplace.",
  "saved.empty.title": "Wala pang naka-save",
  "saved.empty.description": "I-tap ang bookmark sa profile o listahan para i-save ito rito.",
  "saved.browse": "Mag-browse sa marketplace",
  "saved.remove": "Alisin",
  "saved.kind.item": "Item",
  "saved.kind.service": "Serbisyo",
  "saved.kind.company": "Kompanya",
  "saved.kind.jobseeker": "Naghahanap ng Trabaho",
  "saved.kind.profile": "Profile",
  "saved.kind.job": "Trabaho",
  "saved.kind.project": "Proyekto",
  "saved.kind.rfq": "RFQ",
  "discovery.jobseekers": "Naghahanap ng Trabaho",
  "discovery.jobs": "Trabaho",
  "discovery.services": "Serbisyo",
  "discovery.companies": "Kompanya",
  "discovery.projects": "Pag-bid sa Proyekto",
  "discovery.rfqs": "Humingi ng Quotation",
  "discovery.marketplace": "Pamilihan",
  "discovery.all": "Lahat",
  "discovery.marketplaceTitle": "Materyales, Produkto at Kagamitan",
  "discovery.jobseekersCta": "I-set up ang profile mo bilang naghahanap ng trabaho",
  "discovery.offerServiceCta": "Mag-alok ng serbisyo",
  "discovery.addCompanyCta": "Idagdag ang kompanya mo",
  "discovery.postJobCta": "Mag-post ng trabaho",
  "discovery.postProjectCta": "Mag-post ng proyekto",
  "discovery.keywords": "Maghanap gamit ang Keyword",
  "discovery.category": "Kategorya",
  "discovery.skillsField": "Mga kasanayan / larangan ng trabaho",
  "discovery.filters": "Mga Filter",
  "discovery.sortBy": "Ayusin Ayon sa",
  "discovery.noResults": "Walang Nahanap na Resulta",
  "discovery.viewDetails": "Tingnan ang Detalye",
  "discovery.save": "I-save",
  "discovery.saved": "Naka-save",
  "discovery.removeSaved": "Alisin sa naka-save",
  "discovery.savedHint": "Naka-save — i-click upang alisin",
  "discovery.providers": "Tuklasin ang mga Provider",
  "discovery.opportunities": "Maghanap ng mga Oportunidad",
  "discovery.browse": "Mag-browse",
  "discovery.refine": "Pinuhin ang paghahanap",
  "discovery.servicesIntent": "Hanapin ang serbisyong kailangan mo.",
  "discovery.jobseekersIntent": "Maghanap ng mga taong maaari mong kunin sa trabaho.",
  "discovery.companiesIntent": "Maghanap ng mga kompanya para sa malalaki o espesyalisadong gawain.",
  "discovery.jobsIntent": "Maghanap ng trabahong angkop sa iyong mga kasanayan.",
  "discovery.projectsIntent": "Maghanap ng mga proyekto at isumite ang iyong panukala.",
  "discovery.rfqsIntent": "Maghanap ng mga kahilingan para sa serbisyo o suplay na kaya mong tugunan at isumite ang iyong sipi.",
  "discovery.marketplaceIntent": "Mamili ng mga materyales, produkto, at kagamitang kailangan sa iyong trabaho.",
  "discovery.keywordsLabel": "Mga Keyword",
  "discovery.locationLabel": "Lokasyon",
  "discovery.allCategories": "Lahat ng Kategorya",
  "discovery.rating": "Rating",
  "discovery.ratingAll": "Lahat",
  "discovery.verification": "Beripikasyon",
  "discovery.verifiedOnly": "Mga beripikado lamang",
  "discovery.clear": "I-clear",
  "discovery.results": "resulta",
  "discovery.sort.rated": "May Pinakamataas na Rating",
  "discovery.sort.newest": "Pinakabago",
  "discovery.sort.price": "Presyo: Mababa hanggang Mataas",
  "discovery.quote": "Humingi ng Sipi",
  "discovery.startingAt": "Simula sa",
  "discovery.from": "Mula sa",
  "discovery.category.Construction": "Konstruksyon",
  "discovery.category.Professional": "Propesyonal",
  "discovery.category.IT": "IT",
  "discovery.category.Electrical": "Elektrikal",
  "discovery.category.Plumbing": "Pagtutubero",
  "discovery.category.Supply": "Suplay",
  "discovery.verifiedProfession": "Beripikadong propesyon",
  "discovery.professionExample": "hal. Nars",
  "discovery.organizationType": "Uri ng organisasyon",
  "discovery.allTypes": "Lahat ng uri",
  "discovery.temporarilyUnavailable": "Pansamantalang hindi available ang marketplace",
  "discovery.loadFailed": "Hindi ma-load ang marketplace",
  "discovery.loadFailedHint": "Hindi ma-load ang mga kasalukuyang listahan sa ngayon.",
  "discovery.tryAgain": "Subukan muli",
  "discovery.broadenSearch": "Subukang palawakin ang mga keyword o lokasyon.",
  "discovery.clearFilters": "I-clear ang mga filter",
  "discovery.jobseekersEmptyHint": "Lalabas dito ang mga profile ng naghahanap ng trabaho habang lumalaki ang komunidad. Samantala, mag-browse sa ibang kategorya:",
  "discovery.emptyHint": "Bumalik sa ibang pagkakataon o mag-browse sa ibang kategorya:",
  "discovery.loadingMore": "Naglo-load pa…",
  "discovery.loadMore": "Mag-load pa",
  "cards.featured": "Tampok",
  "cards.availableNow": "Available ngayon",
  "cards.noRatings": "Wala pang rating",
  "cards.yearsExperience": "taong karanasan",
  "cards.applicants": "mga aplikante",
  "cards.checking": "Sinusuri…",
  "cards.checkingApplication": "Sinusuri ang aplikasyon…",
  "cards.unableToVerify": "Hindi ma-verify",
  "cards.unableToVerifyApplication": "Hindi ma-verify ang aplikasyon",
  "cards.applied": "Nakapag-apply",
  "cards.shortlisted": "Nasa shortlist",
  "cards.hired": "Natanggap sa trabaho 🎉",
  "cards.applyNow": "Mag-apply Ngayon",
  "cards.bids": "mga bid",
  "cards.deadline": "Huling araw:",
  "cards.budget": "Badyet",
  "cards.estimatedBudget": "Tinatayang Badyet",
  "cards.privateEstimate": "Inyong pagtataya (pribado)",
  "cards.budgetUnavailable": "Hindi ibinigay ang badyet",
  "cards.submitBid": "Magsumite ng Bid",
  "cards.quote": "Sipi",
  "cards.quotes": "Mga Sipi",
  "cards.due": "Takdang petsa:",
  "cards.lineItem": "item",
  "cards.lineItems": "mga item",
  "cards.submitQuote": "Magsumite ng Sipi",
  "cards.viewRequest": "Tingnan ang kahilingan",
  "cards.inStock": "nasa stock",
  "cards.inquireToBuy": "Quotation para bumili",
  "cards.rent": "Paupahan",
  "cards.buy": "Bilhin",
  "cards.since": "Mula noong",
  "cards.viewCompany": "Tingnan ang kompanya",
};
